export default __webpack_public_path__ + "graphics/experience-360.240141dd.jpg";